(ns story-builder.story-editor.animation-sidebar.constant)

(def supported-text-animations
  #{"fade-in" "fade-out" "fly-in-top" "fly-in-right" "fly-in-bottom" "fly-in-left"
    "rotate-in-right" "rotate-in-left" "rotate" "pulse" "scale-fade-down" "scale-fade-up"
    "twirl-in-clockwise" "twirl-in-counterclockwise" "whoosh-in-left" "whoosh-in-right" "drop"})

(def css-timing->anime-easing
  {"linear" "linear"
   "ease" "cubicBezier(.25,.1,.25,1)"
   "ease-in" "cubicBezier(.42,0,1,1)"
   "ease-out" "cubicBezier(0,0,.58,1)"
   "ease-in-out" "cubicBezier(.42,0,.58,1)"})

(def animation-type->anime-easing
  {"drop" "easeOutBack"
   "pulse" "easeInOutSine"
   "whoosh-in-left" "easeOutCubic"
   "whoosh-in-right" "easeOutCubic"
   "rotate" "easeOutQuad"
   "rotate-in-left" "easeOutQuad"
   "rotate-in-right" "easeOutQuad"
   "twirl-in-clockwise" "easeOutQuad"
   "twirl-in-counterclockwise" "easeOutQuad"
   "scale-fade-down" "easeOutQuad"
   "scale-fade-up" "easeOutQuad"
   "fly-in-top" "easeOutQuad"
   "fly-in-right" "easeOutQuad"
   "fly-in-bottom" "easeOutQuad"
   "fly-in-left" "easeOutQuad"
   "fade-out" "linear"
   "fade-in" "linear"})

(def animation->props
  {"fade-in"                   {:opacity [0 100]}
   "fade-out"                  {:opacity [100 0]}
   "fly-in-top"                {:keyframes [{:opacity 0 :translateY "-100%" :offset 0}
                                            {:opacity 1 :offset 0.01}
                                            {:translateY "0%" :offset 1}]}
   "fly-in-bottom"             {:keyframes [{:opacity 0 :translateY "100%" :offset 0}
                                            {:opacity 1 :offset 0.01}
                                            {:translateY "0%" :offset 1}]}
   "fly-in-left"               {:keyframes [{:opacity 0 :translateX "-100%" :offset 0}
                                            {:opacity 1 :offset 0.01}
                                            {:translateX "0%" :offset 1}]}
   "fly-in-right"              {:keyframes [{:opacity 0 :translateX "100%" :offset 0}
                                            {:opacity 1 :offset 0.01}
                                            {:translateX "0%" :offset 1}]}
   "rotate-in-left"            {:keyframes [{:opacity 0 :translateX "-500%" :rotateZ -360 :offset 0}
                                            {:opacity 1 :offset 0.01}
                                            {:translateX "0%" :rotateZ 0 :offset 1}]}
   "rotate-in-right"           {:keyframes [{:opacity 0 :translateX "500%" :rotateZ 360 :offset 0}
                                            {:opacity 1 :offset 0.01}
                                            {:translateX "0%" :rotateZ 0 :offset 1}]}
   "rotate"                    {:rotateZ [0 360]}
   "pulse"                     {:keyframes [{:scale 1 :offset 0}
                                            {:scale 0.95 :offset 0.25}
                                            {:scale 1.05 :offset 0.75}
                                            {:scale 1 :offset 1}]}
   "scale-fade-down"           {:scale [1.3 1] :opacity [0 100]}
   "scale-fade-up"             {:scale [0.7 1] :opacity [0 100]}
   "twirl-in"                  {:rotateZ [540 0] :scale [0.1 1] :opacity [0 100]}
   "twirl-in-clockwise"        {:rotateZ [-540 0] :scale [0.1 1] :opacity [0 100]}
   "twirl-in-counterclockwise" {:rotateZ [540 0] :scale [0.1 1] :opacity [0 100]}
   "whoosh-in-left"            {:translateX ["-250%" "0%"] :scale [0.15 1] :opacity [0 100]}
   "whoosh-in-right"           {:translateX ["250%" "0%"] :scale [0.15 1] :opacity [0 100]}
   "drop"                      {:keyframes [{:opacity 0 :translateY "-250%" :easing "cubicBezier(.5,0,1,1)" :offset 0}
                                            {:opacity 1 :translateY "0%" :easing "cubicBezier(0,0,.5,1)" :offset 0.29}
                                            {:translateY "-70.3%" :easing "cubicBezier(.5,0,1,1)" :offset 0.45}
                                            {:translateY "0%" :easing "cubicBezier(0,0,.5,1)" :offset 0.61}
                                            {:translateY "-23.9%" :easing "cubicBezier(.5,0,1,1)" :offset 0.71}
                                            {:translateY "0%" :easing "cubicBezier(0,0,.5,1)" :offset 0.80}
                                            {:translateY "-9%" :easing "cubicBezier(.5,0,1,1)" :offset 0.85}
                                            {:translateY "0%" :easing "cubicBezier(0,0,.5,1)" :offset 0.92}
                                            {:translateY "-3.9%" :easing "cubicBezier(.5,0,1,1)" :offset 0.96}
                                            {:translateY "0%" :easing "cubicBezier(0,0,.5,1)" :offset 1}]}
   "zoom-in"                   {:keyframes [{:opacity 0 :scale 1 :offset 0}
                                            {:opacity 1 :scale 1 :offset 0.01}
                                            {:scale 3 :offset 1}]}
   "zoom-out"                  {:keyframes [{:opacity 0 :scale 3 :offset 0}
                                            {:opacity 1 :scale 3 :offset 0.01}
                                            {:scale 1 :offset 1}]}
   "pan-left"                  {:keyframes [{:opacity 0 :scale 1.25 :translateX "-20%" :offset 0}
                                            {:opacity 1 :scale 1.25 :offset 0.01}
                                            {:scale 1.25 :translateX "0%" :offset 1}]}
   "pan-right"                 {:keyframes [{:opacity 0 :scale 1.25 :translateX "0%" :offset 0}
                                            {:opacity 1 :scale 1.25 :offset 0.01}
                                            {:scale 1.25 :translateX "-20%" :offset 1}]}
   "pan-up"                    {:keyframes [{:opacity 0 :scale 1.25 :translateY "-20%" :offset 0}
                                            {:opacity 1 :scale 1.25 :offset 0.01}
                                            {:scale 1.25 :translateY "0%" :offset 1}]}
   "pan-down"                  {:keyframes [{:opacity 0 :scale 1.25 :translateY "0%" :offset 0}
                                            {:opacity 1 :scale 1.25 :offset 0.01}
                                            {:scale 1.25 :translateY "-20%" :offset 1}]}})
